import * as React from 'react';
/**
 *
 * Original name: mic
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1077
 *
 */
export const MicLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M11.75 15c2.313 0 3.75-1.437 3.75-3.75v-3.5C15.5 5.437 14.063 4 11.75 4 9.437 4 8 5.437 8 7.75v3.5C8 13.563 9.437 15 11.75 15ZM9.5 7.75c0-1.493.757-2.25 2.25-2.25 1.493 0 2.25.757 2.25 2.25v3.5c0 1.493-.757 2.25-2.25 2.25-1.493 0-2.25-.757-2.25-2.25v-3.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M18.495 11.25h-1.5c0 3.483-1.765 5.25-5.245 5.25-3.48 0-5.245-1.767-5.245-5.25h-1.5c0 4.033 2.173 6.448 5.995 6.723V20h1.5v-2.027c3.822-.275 5.995-2.69 5.995-6.723Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
